
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';

@MergeSchema({
    entity: ActivityEntityName.Site
})
export class JobSiteMergeData {

    @MergeField()
    street: string;

    @MergeField()
    suburb: string;

    @MergeField()
    state: string;

    @MergeField()
    postcode: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    contactName: string;

    @MergeField(
        {
            displayName: "Contact Phone (Deprecated: use contactHomePhone)"
        }
    )
    contactPhone: string;

    @MergeField()
    contactMobile: string;

    @MergeField()
    contactHomePhone: string;

    @MergeField()
    contactWorkPhone: string;

    @MergeField()
    contactEmail: string;

    @MergeField()
    name: string;

    @MergeField()
    country: string;

    @MergeField()
    county: string;

    @MergeField()
    postalCode: string;

    @MergeField()
    placeId: string;

    siteId: string;
    customFields: any;
}

export const JobSiteMergeSchema = getSchema(JobSiteMergeData);